import type { ReactNode } from "react";

type ProfileSummaryProps = {
	name: string;
	status: string;
	avatar: ReactNode;
	actionLabel: string;
	actionDisabled?: boolean;
	onAction: () => void;
};

export function ProfileSummary({
	name,
	status,
	avatar,
	actionLabel,
	actionDisabled = false,
	onAction,
}: ProfileSummaryProps) {
	return (
		<div className="personal-profile-row">
			{avatar}
			<div className="personal-profile-copy">
				<strong>{name}</strong>
				<span>{status}</span>
			</div>
			<button
				className="mine-auth-button"
				disabled={actionDisabled}
				onClick={onAction}
				type="button"
			>
				{actionLabel}
			</button>
		</div>
	);
}
